import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Calculator from "@/pages/Calculator";
import Results from "@/pages/Results";
import ThankYou from "@/pages/ThankYou";
import Legal from "@/pages/Legal";
import { CalcProvider } from "@/context/CalcContext";

export default function App() {
  return (
    <div className="App">
      <CalcProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/calculer" element={<Calculator />} />
            <Route path="/resultats" element={<Results />} />
            <Route path="/merci" element={<ThankYou />} />
            <Route path="/mentions-legales" element={<Legal />} />
          </Routes>
        </BrowserRouter>
      </CalcProvider>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#0f172a",
            color: "#fff",
            border: "1px solid #1e293b",
            fontFamily: "'Bai Jamjuree', sans-serif",
          },
        }}
      />
    </div>
  );
}
